define('app/factories/yadisa_sale_factory',['app/setup', 'app/views/yadisa_sale_view', 'app/collections/sale_collection'], function(takhfifan, saleView) {
  $(function($) {

    /*
     * Load this view only once we have a form key. Otherwise we get
     * a race condition for sessions, because all requests connecting
     * without a cookie will receive a different session, thereby
     * overwriting the previous session.
     */
    var alreadyInitializedYadisaSalesViews = false;

    function initSaleView(){
      if(takhfifan.formKey && !alreadyInitializedYadisaSalesViews) {
        alreadyInitializedYadisaSalesViews = true;
        var deals = new takhfifan.SaleCollection();
        var productIds = [];

        $('.tkh-yadisa-sale').each(function(){
          var $el = $(this);
          var dealId = parseInt($el.data('product-id'));
          if(_.indexOf(productIds, dealId) === -1){
            productIds.push(dealId);
          }
          var sale = new takhfifan.Sale({id: dealId});
          new takhfifan.YadisaSaleView({el: $el, model: sale});
          deals.push(sale);
        });

        if(productIds.length){
          deals.fetch({
            traditional: false,
            data: {id: productIds}
          });
        }
      }
    }

    takhfifan.eventHub.on('formkey', function(formKey) {
      initSaleView();
    });

    initSaleView();
  });
});

